import { computePosition, autoUpdate, offset, flip, shift } from '@floating-ui/dom';

class Navigation {
  constructor() {
    this.buttonEl = document.querySelectorAll('[data-dropdown-toggle]')
    this.dropdownEl = document.querySelectorAll('[data-dropdown]')

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);

    this.isOpen = false;

    this.dropdownElStack = [];

    this.supportsPassive = undefined;
    this.addEventListeners();
  }

  addEventListeners() {
    this.buttonEl.forEach(el => el.addEventListener('click', this.toggleDropdown));
    this.dropdownEl.forEach(el => el.addEventListener('focusout', this.onFocusOut));

    document.addEventListener('click', (evt) => {
      if (typeof this.dropdownElStack.reverse()[0] !== 'undefined') {
        const currentDropdownEl = this.dropdownElStack.reverse()[0];
        const isWithinBoundaries = currentDropdownEl.contains(evt.target);
        if (!isWithinBoundaries && evt.target !== currentDropdownEl.previousElementSibling) {
          this.hideAll(); // Close on click outside dropdown
        }
      }
    });

    document.addEventListener('keydown', (evt) => {
      const key = evt.key;
      if (key === 'Escape') {
        this.hideAll(); // Esc kills everything
      }
    });
  }

  blockClicks(evt) {
    if (typeof evt !== 'undefined' && evt.currentTarget.hasAttribute('data-dropdown-toggle')) {
      evt.preventDefault();
    }
  }

  blockPropagation(evt) {
    evt.stopPropagation();
  }

  cleanup(toggleEl, dropdownEl) {
    autoUpdate(
      toggleEl,
      dropdownEl,
      () => computePosition(toggleEl, dropdownEl, {
          placement: 'bottom',
          middleware: [
            offset({
              mainAxis: 18
            }),
            flip(),
            shift()
          ]
        }
      ).then(({ x, y }) => {
        let source = {
          left: `${x}px`,
          top: `${y}px`,
        };
        if (dropdownEl.classList.contains('c-dropdown--style-mega')) {
          source = {
            right: 0,
            left: 0,
            top: `${y}px`,
          };
        }
        Object.assign(dropdownEl.style, source);
      }),
    );
  }

  toggleDropdown(evt) {
    this.blockClicks(evt);

    const currentDropdownEl = evt.currentTarget.nextElementSibling;
    const lastDropdownEl = this.dropdownElStack.reverse()[0];

    if (lastDropdownEl !== 'undefined' && lastDropdownEl !== currentDropdownEl) {
      this.hideAll();
    }

    this.isOpen = !this.isOpen;

    // Only run autoUpdate when dropdown is visible/mounted for better performance
    // @see https://floating-ui.com/docs/autoUpdate#usage
    if (this.isOpen) {
      this.cleanup(evt.currentTarget, currentDropdownEl);
      window.setTimeout(() => {
        currentDropdownEl.focus({ preventScroll: true })
      }, 0);
    }

    evt.currentTarget.ariaExpanded = evt.currentTarget.ariaExpanded !== 'true';
    evt.currentTarget.classList.toggle('is-visible');

    this.dropdownElStack.push(currentDropdownEl);
  }

  hideAll() {
    if (!this.isOpen) {
      return; // only run when needed
    }

    this.isOpen = false;

    this.buttonEl.forEach(el => {
      el.ariaExpanded = 'false';
    });

    this.dropdownEl.forEach(el => {
      el.previousElementSibling.classList.remove('is-visible');
    });

    this.dropdownElStack = []; // reset stack
  }

  onFocusOut(evt) {
    const focusEl = evt.relatedTarget || document.activeElement;
    if (this.dropdownElStack.length > 0 && !this.dropdownElStack[0].contains(focusEl)) {
      if (evt.currentTarget.previousElementSibling.isEqualNode(focusEl)) {
        return;
      }
      this.hideAll();
    }
  }
}
export default new Navigation();
